import config from "../configure/config";
import async from "async";
import bigInt from "big-integer";
import {
  CLAIM,
  CLAIM_RETURNED,
  CLAIM_HODLER,
  CLAIM_HODLER_RETURNED,
  PUBLIC_CLAIM,
  CONFIGURE,
  CONFIGURE_RETURNED,
  ERROR,
  GET_BALANCES,
  GET_BALANCES_RETURNED,
  GET_PUBLIC_PRESALE_INFO,
  GET_PUBLIC_PRESALE_INFO_RETURNED,
  STAKE,
  STAKE_V1,
  STAKE_RETURNED,
  UNSTAKE,
  UNSTAKE_RETURNED,
  UPDATE_REWARDS,
  INVEST,
  INVEST_RETURNED,
  PUBLIC_INVEST,
  GET_POOLS_SUMMARY,
  GET_POOLS_SUMMARY_RETURNED,
  APPLY,
  APPLY_RETURNED,
  LOCK_LIQUIDITY,
  LOCK_LIQUIDITY_RETURNED,
  VOTE,
  VOTE_RETURNED,
  GET_START_STATS,
  GET_START_STATS_RETURNED,
  COLLECT_FUND,
  COLLECT_FUND_RETURNED,
  CANCEL_PRESALE,
  CANCEL_PRESALE_RETURNED,
  SEND_UNSOLD_TOKENS,
  SEND_UNSOLD_TOKENS_RETURNED,
  MOVE_STAKE,
  MOVE_STAKE_RETURNED,
  WRITE,
  CUSTOM_WRITE,
  WRITE_RETURNED,
  THEME_CHANGE,
  THEME_CHANGE_RETURNED,
  toFixed,
  sleep,
  UNSTAKE_V1,
  ALLOW_CLAIM,
  ALLOW_CLAIM_RETURNED,
  GET_REFUND,
  GET_REFUND_RETURNED,
  SWAP,
  SWAP_RETURNED,
  defaultFundingAddress,
  isSameAddress,
  poolsSummaryUrl,
  buidlStatsUrl,
  GET_STAKING_POOLS_INFO,
  GET_GENERALS_INFO,
  PUBLIC_CLAIM_RETURNED,
  GET_DEV_FEES,
  GET_DEV_FEES_RETURNED,
  THEME_MODE_CHANGE,
  THEME_MODE_CHANGE_RETURNED,
  ENVIRONMENT,
  GET_MIN_CREATOR_STAKED_BALANCE,
  GET_MIN_CREATOR_STAKED_BALANCE_RETURNED,
  fundingTokens,
  GET_SWAP_INFO,
  GET_SWAP_INFO_RETURNED,
} from "../constants";

import {
  _getBUIDLPrice,
  _callClaimReward,
  _callClaimHodler,
  _getStakingPool,
  _getFactoryPool,
  _getBnbBalance,
  _getBUIDLBalance,
  _getStakedBalance,
  _getSwapData,
  _callApply,
  _checkApproval,
  _callVote,
  _callUnstake,
  _callUnstakeV1,
  _callMigrate,
  _callStake,
  _callLockLiquidity,
  _callGetRefund,
  _callInvest,
  _callAllowClaim,
  _callSendUnSoldTokens,
  _callCancelPresale,
  _callCollectFunds,
  _callWrite,
  _callSwap,
  _getPresaleAbiByBscsId,
  _getPresaleAbiByVersion,
  _getMinCreatorStakedBalance,
} from "./private";

import Web3 from "web3";

import { injected, injectedtw, walletconnect, WalletLink } from "./connectors";
import { getStakingPools, getVesting } from "../components/stake/api/pools";
import { api } from "../components/stake/api";
import { getThemeFromURL } from "../utils/getThemeFromURL";
import { expandFixed } from "../components/stake/constants/constants";

const Dispatcher = require("flux").Dispatcher;
const Emitter = require("events").EventEmitter;

const dispatcher = new Dispatcher();
const emitter = new Emitter();

export const rpcUrls = {
  base:
    ENVIRONMENT === "mainnet"
      ? [
          // "https://mainnet.base.org",
          "https://base-rpc.publicnode.com",
          "https://developer-access-mainnet.base.org",
        ]
      : ["https://base-sepolia.publicnode.com"],
  pulse: ["https://base-sepolia.publicnode.com"],
  // pulse: ["https://rpc.pulsechain.com"],
};

class Store {
  constructor() {
    const chainIds = {
      // bsc: 56,
      // mtc: 137,
      // ftm: 250,
      // eth: 1,
      // avax: 43114,
      base: ENVIRONMENT === "mainnet" ? 8453 : 84532,
      pulse: 369,
    };
    const themeType = getThemeFromURL(window.location.hostname)
      ? getThemeFromURL(window.location.hostname)
      : localStorage.getItem("THEME_TYPE") || "base";

    this.store = {
      themeType,
      currentBlock: 0,
      account: {},
      web3: null,
      connectorsByName: {
        MetaMask: injected,
        TrustWallet: injectedtw,
        WalletConnect: walletconnect(chainIds[themeType]),
        Coinbase: WalletLink(chainIds[themeType]),
      },
      web3context: null,
      languages: [
        {
          language: "English",
          code: "en",
        },
      ],

      tokenAddress: config[themeType].BUIDLTokenAddress,
      tokenAbi: config[themeType].BUIDLTokenAbi,

      StakingToken: config[themeType].stakingToken,
      StakingTokenAbi: config[themeType].ERC20Abi,
      StakingTokenName: config[themeType].stakingTokenName,
      StakedContractAbi: config[themeType].starterStakingAbi,
      StakedContractAddress: config[themeType].starterStaking,

      StarterInfoAbi: config[themeType].starterInfoAbi,
      StarterInfoAddress: config[themeType].starterInfoAddress,

      starterVestingContract: config[themeType].starterVestingAddress,
      factory: {
        factoryAddress: config[themeType].factoryAddress,
        factoryAbi: config[themeType].factoryAbi,

        starterInfoAddress: config[themeType].starterInfoAddress,
        starterInfoAbi: config[themeType].starterInfoAbi,

        presaleAbi: config[themeType].starterPresaleAbi,
      },

      publicPresales: {},
      presales: {},
      vestings: {},
      stakingPools: {},
      themeMode: localStorage.getItem("THEME_MODE") ?? "dark",
      devFeePercentage: {
        0: 0,
        1: 0,
        2: 0,
      },
      generals: {},
      bnbBalance: bigInt(),
      buidlBalance: bigInt(),
      startPrice: 0,
      totalStakedLocked: bigInt(),
      stakingTokenBalance: bigInt(),
      stakedBalance: bigInt(),
      totalStakedBalance: bigInt(),
      v1StakedBalance: bigInt(),
      lastStakedTime: 0,
      lastUnstakedTime: 0,
      lastInvestTimestamp: 0,
      minStakeTime: 0,
      minUnstakeTime: 0,
      firstStakedTimestamp: 0,
      isLongStaker: false,
      burnFee: 50,

      bnbRewardBalance: bigInt(),
      factoryBalance: bigInt(),
      lockedBalance: bigInt(),
      stakedAndLockedBalance: bigInt(),
      startStats: {},
      stakingPool: {},
      factoryPool: {
        address: "0x00000000000000000",
        starterInfo: "0x00000000000000000",
        stakingPool: "0x00000000000000000",
        owner: "0x00000000000000000",
        pendingOwner: "0x00000000000000000",
      },
      swapData: {
        swapSymbol: config[themeType].swapSymbol,
        swapTokenAddress: config[themeType].swapToken,
        swapTokenAbi: config[themeType].swapTokenAbi,
        swapRouterAddress: config[themeType].swapRouter,
        swapRouterAbi: config[themeType].swapRouterAbi,
        swapTokenBalance: bigInt(),
        swapPrice: bigInt(),
      },
      rpcIndex: 0,
    };

    dispatcher.register(
      function (payload) {
        switch (payload.type) {
          case THEME_CHANGE:
            this.themeChange(payload);
            break;
          case THEME_MODE_CHANGE:
            this.themeModeChange(payload);
            break;
          case CONFIGURE:
            this.configure(payload);
            break;
          case GET_BALANCES:
            this.getBalances(payload);
            break;
          case GET_MIN_CREATOR_STAKED_BALANCE:
            this.getMinCreatorStakedBalance(payload);
            break;
          case GET_DEV_FEES:
            this.getDevFees(payload);
            break;
          case STAKE:
            this.stake(payload);
            break;
          case UNSTAKE:
            this.unstake(payload);
            break;
          case STAKE_V1:
            this.stakeV1(payload);
            break;
          case UNSTAKE_V1:
            this.unstakeV1(payload);
            break;
          case CLAIM:
            this.claim(payload);
            break;
          case CLAIM_HODLER:
            this.claimHodler(payload);
            break;
          case PUBLIC_CLAIM:
            this.claim(payload, "public");
            break;
          case UPDATE_REWARDS:
            this.updateRewards(payload);
            break;

          case INVEST:
            this.invest(payload);
            break;
          case GET_SWAP_INFO:
            this.swapInfo(payload);
            break;
          case PUBLIC_INVEST:
            this.invest(payload, "public");
            break;
          case GET_POOLS_SUMMARY:
            this.getPoolsSummary();
            break;
          case APPLY:
            this.apply(payload);
            break;
          case GET_PUBLIC_PRESALE_INFO:
            this.getPublicPresaleInfo(payload);
            break;
          case GET_STAKING_POOLS_INFO:
            this.getStakingPoolsInfo(payload);
            break;
          case GET_GENERALS_INFO:
            this.getGeneralsInfo(payload);
            break;
          case LOCK_LIQUIDITY:
            this.lockLiquidity(payload);
            break;
          case VOTE:
            this.vote(payload);
            break;
          case GET_START_STATS:
            this.getStartStats(payload);
            break;
          case COLLECT_FUND:
            this.collectFunds(payload);
            break;
          case CANCEL_PRESALE:
            this.cancelPresale(payload);
            break;
          case SEND_UNSOLD_TOKENS:
            this.sendUnsoldTokens(payload);
            break;
          case ALLOW_CLAIM:
            this.allowClaim(payload);
            break;
          case MOVE_STAKE:
            this.moveStake(payload);
            break;
          case WRITE:
            this.write(payload);
            break;
          case CUSTOM_WRITE:
            this.customWrite(payload);
            break;
          case GET_REFUND:
            this.getRefund(payload);
            break;
          case SWAP:
            this.swap(payload);
            break;
          default: {
          }
        }
      }.bind(this)
    );
  }

  getStore(index) {
    return this.store[index];
  }

  setStore(obj) {
    this.store = {
      ...this.store,
      ...obj,
    };
    return emitter.emit("StoreUpdated");
  }

  initializeStore = () => {
    const themeType = store.getStore("themeType");
    const chainIds = {
      // bsc: 56,
      // mtc: 137,
      // ftm: 250,
      // eth: 1,
      // avax: 43114,
      pulse: 396,
      base: ENVIRONMENT === "mainnet" ? 8453 : 84532,
    };
    this.store = {
      ...this.store,
      connectorsByName: {
        MetaMask: injected,
        TrustWallet: injectedtw,
        WalletConnect: walletconnect(chainIds[themeType]),
        Coinbase: WalletLink(chainIds[themeType]),
      },
      currentBlock: 0,
      tokenAddress: config[themeType].BUIDLTokenAddress,
      tokenAbi: config[themeType].BUIDLTokenAbi,

      StakingToken: config[themeType].stakingToken,
      StakingTokenAbi: config[themeType].ERC20Abi,
      StakingTokenName: config[themeType].stakingTokenName,
      StakedContractAbi: config[themeType].starterStakingAbi,
      StakedContractAddress: config[themeType].starterStaking,

      StarterInfoAbi: config[themeType].starterInfoAbi,
      StarterInfoAddress: config[themeType].starterInfoAddress,

      starterVestingContract: config[themeType].starterVestingAddress,
      factory: {
        factoryAddress: config[themeType].factoryAddress,
        factoryAbi: config[themeType].factoryAbi,

        starterInfoAddress: config[themeType].starterInfoAddress,
        starterInfoAbi: config[themeType].starterInfoAbi,

        presaleAbi: config[themeType].starterPresaleAbi,
      },
      publicPresales: {},
      presales: {},
      vestings: {},
      stakingPools: {},
      themeMode: localStorage.getItem("THEME_MODE") ?? "dark",
      devFeePercentage: {
        0: 0,
        1: 0,
        2: 0,
      },
      generals: {},
      bnbBalance: bigInt(),
      buidlBalance: bigInt(),
      startPrice: 0,
      totalStakedLocked: bigInt(),
      stakingTokenBalance: bigInt(),
      stakedBalance: bigInt(),
      totalStakedBalance: bigInt(),
      v1StakedBalance: bigInt(),
      lastStakedTime: 0,
      lastUnstakedTime: 0,
      lastInvestTimestamp: 0,
      minStakeTime: 0,
      minUnstakeTime: 0,
      firstStakedTimestamp: 0,
      isLongStaker: false,
      burnFee: 50,

      bnbRewardBalance: bigInt(),
      factoryBalance: bigInt(),
      lockedBalance: bigInt(),
      stakedAndLockedBalance: bigInt(),
      startStats: {},
      stakingPool: {},
      factoryPool: {
        address: "0x00000000000000000",
        starterInfo: "0x00000000000000000",
        stakingPool: "0x00000000000000000",
        owner: "0x00000000000000000",
        pendingOwner: "0x00000000000000000",
      },
      swapData: {
        swapSymbol: config[themeType].swapSymbol,
        swapTokenAddress: config[themeType].swapToken,
        swapTokenAbi: config[themeType].swapTokenAbi,
        swapRouterAddress: config[themeType].swapRouter,
        swapRouterAbi: config[themeType].swapRouterAbi,
        swapTokenBalance: bigInt(),
        swapPrice: bigInt(),
      },
      rpcIndex: 0,
    };
  };

  themeChange = ({ content: { themeType } }) => {
    localStorage.setItem("THEME_TYPE", themeType);
    const orgThemeType = store.getStore("themeType");
    store.setStore({ themeType });
    if (orgThemeType !== themeType) {
      store.initializeStore();
      store.getPoolsSummary();
      store.getStakingPoolsInfo();
      store.getGeneralsInfo();
      store.getDevFee();
      store.getStakingAndFactoryInfo();
      store.getStartStats();
      return emitter.emit(THEME_CHANGE_RETURNED);
    }
  };

  themeModeChange = ({ content: { themeMode } }) => {
    localStorage.setItem("THEME_MODE", themeMode);
    store.setStore({ themeMode });
    return emitter.emit(THEME_MODE_CHANGE_RETURNED, themeMode);
  };

  configure = async () => {
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const currentBlock = await web3.eth.getBlockNumber();

    store.setStore({
      currentBlock: currentBlock,
    });

    window.setTimeout(() => {
      emitter.emit(CONFIGURE_RETURNED);
    }, 100);
  };

  getRpcUrl = async () => {
    const themeType = store.getStore("themeType");
    let rpcIndex = store.getStore("rpcIndex");
    // let rpcIndex = 0;
    while (1) {
      for (rpcIndex = 0; rpcIndex < rpcUrls[themeType].length; rpcIndex++) {
        try {
          store.setStore({
            rpcIndex,
          });
          return rpcUrls[themeType][rpcIndex];
        } catch (error) {
          await sleep(1000);
        }
      }
      await sleep(10000);
    }
  };

  getBalances = async () => {
    try {
      const themeType = store.getStore("themeType");
      const account = store.getStore("account");
      const rpcUrl = await this.getRpcUrl();
      const web3 = new Web3(rpcUrl);

      const currentBlock = await web3.eth.getBlockNumber();
      store.setStore({
        currentBlock: currentBlock,
      });

      async.parallel(
        [
          (callbackInnerInner) => {
            _getBnbBalance(
              store,
              dispatcher,
              emitter,
              web3,
              account,
              callbackInnerInner
            );
          },
          (callbackInnerInner) => {
            _getBUIDLBalance(
              store,
              dispatcher,
              emitter,
              web3,
              account,
              callbackInnerInner
            );
          },
          (callbackInnerInner) => {
            _getStakedBalance(
              store,
              dispatcher,
              emitter,
              web3,
              account,
              callbackInnerInner
            );
          },
          (callbackInnerInner) => {
            _getBUIDLPrice(callbackInnerInner, themeType);
          },
        ],
        (err, data) => {
          if (err) {
            console.log("GET_BALANCES error", err, data);
            return emitter.emit(ERROR, err);
          }

          store.setStore({
            bnbBalance: data[0],
            buidlBalance: data[1]?.balance || bigInt(),
            totalStakedLocked: data[1]?.totalStakedLocked || bigInt(),
            stakingTokenBalance: data[1]?.stakingTokenBalance || bigInt(),
            stakedBalance: data[2]?.balance || bigInt(),
            totalStakedBalance: data[2]?.totalStakedBalance || bigInt(),
            minCreatorStakedBalance:
              data[2]?.minCreatorStakedBalance || bigInt(),
            isCertifiedAllowed: data[2]?.isCertifiedAllowed || false,
            v1StakedBalance: data[2]?.v1Balance || bigInt(),
            lastStakedTime: data[2]?.lastStakedTime || bigInt(),
            lastUnstakedTime: data[2]?.lastUnstakedTime || bigInt(),
            lastInvestTimestamp: data[2]?.lastInvestTimestamp || bigInt(),
            minStakeTime: data[2]?.minStakeTime || bigInt(),
            minUnstakeTime: data[2]?.minUnstakeTime || bigInt(),
            firstStakedTimestamp: data[2]?.firstStakedTimestamp || bigInt(),
            isLongStaker: data[2]?.isLongStaker || bigInt(),
            burnFee: data[2]?.burnFee || bigInt(),
            factoryBalance: 0,
            lockedBalance: bigInt(),
            stakedAndLockedBalance: data[2]?.totalStakedBalance || bigInt(),
            buidlPrice: data[3],
          });
          return emitter.emit(GET_BALANCES_RETURNED);
        }
      );
    } catch (error) {
      console.error("GET_BALANCES", error);
      return emitter.emit(ERROR, error);
    }
  };

  swapInfo = async () => {
    try {
      const account = store.getStore("account");
      const rpcUrl = await this.getRpcUrl();
      const web3 = new Web3(rpcUrl);

      const currentBlock = await web3.eth.getBlockNumber();
      store.setStore({
        currentBlock: currentBlock,
      });

      const _swapData = await _getSwapData(store, web3, account);

      store.setStore({
        swapData: _swapData,
      });

      return emitter.emit(GET_SWAP_INFO_RETURNED);
    } catch (error) {
      console.error("GET_SWAP_INFO", error);
      return emitter.emit(ERROR, error);
    }
  };

  getMinCreatorStakedBalance = async ({ content: { fundingTokenAddress } }) => {
    try {
      const account = store.getStore("account");
      const rpcUrl = await this.getRpcUrl();
      const web3 = new Web3(rpcUrl);

      const minCreatorStakedBalance = await _getMinCreatorStakedBalance(
        store,
        web3,
        account,
        fundingTokenAddress
      );

      console.log({ minCreatorStakedBalance });

      store.setStore({
        minCreatorStakedBalance: minCreatorStakedBalance || bigInt(),
      });
      return emitter.emit(GET_MIN_CREATOR_STAKED_BALANCE_RETURNED);
    } catch (error) {
      console.error("GET_MIN_CREATOR_STAKED_BALANCE", error);
      return emitter.emit(ERROR, error);
    }
  };

  getStartStats = async () => {
    const themeType = store.getStore("themeType");
    try {
      const url = buidlStatsUrl[themeType];
      const res = await api.get(url);
      const statsJson = res.data;
      store.setStore({
        startStats: statsJson,
      });
      return emitter.emit(GET_START_STATS_RETURNED);
    } catch (error) {
      console.error("GET_START_STATS_RETURNED", error);
      return emitter.emit(ERROR, error);
    }
  };

  getStakingPoolsInfo = async () => {
    const account = store.getStore("account");

    const rpcUrl = await this.getRpcUrl();
    const web3 = new Web3(rpcUrl);

    const stakingPools = await getStakingPools(account.address, web3);

    const vestings = await getVesting(account.address, web3, stakingPools);

    store.setStore({
      stakingPools: stakingPools,
      vestings: vestings,
    });
  };

  getGeneralsInfo = async () => {
    try {
      const generalInfo = await api.get(
        ENVIRONMENT === "mainnet"
          ? "https://base.api.starter.xyz/base/staking/generals"
          : "https://test.base.api.starter.xyz/base/staking/generals"
      );
      const _generals = generalInfo.data;

      console.info("generals >> ", _generals);

      store.setStore({
        generals: _generals,
      });
    } catch (err) {
      console.error("generals error >> ", err);
    }
  };

  getDevFees = async () => {
    try {
      const rpcUrl = await this.getRpcUrl();
      const web3 = new Web3(rpcUrl);

      const factory = store.getStore("factory");

      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );

      const presaleDevFeePercentage = await starterInfoContract.methods
        .getDevFeePercentage("0")
        .call();
      const communityIdoDevFeePercentage = await starterInfoContract.methods
        .getDevFeePercentage("1")
        .call();
      const deGenDevFeePercentage = await starterInfoContract.methods
        .getDevFeePercentage("2")
        .call();

      const devFeePercentage = {
        0: presaleDevFeePercentage,
        1: communityIdoDevFeePercentage,
        2: deGenDevFeePercentage,
      };

      store.setStore({
        devFeePercentage,
      });
      return emitter.emit(GET_DEV_FEES_RETURNED);
    } catch (error) {
      console.error("GET_DEV_FEES", error);
      return emitter.emit(ERROR, error);
    }
  };

  getPublicPresaleInfo = async ({ content: { presaleIndex } }) => {
    try {
      const lockedLiquidityAddress = store.getStore("starterVestingContract");
      const stakedAndLockedBalance = store.getStore("stakedAndLockedBalance");
      const stakingTokenName = store.getStore("StakingTokenName");
      const stakingTokenAddress = store.getStore("StakingToken");
      const presales = store.getStore("publicPresales");
      const themeType = store.getStore("themeType");
      const account = store.getStore("account");
      const factory = store.getStore("factory");

      const rpcUrl = await this.getRpcUrl();
      const web3 = new Web3(rpcUrl);

      const bscsLiqLockAddress = lockedLiquidityAddress;
      const voteAvailable = stakedAndLockedBalance;

      let publicPresale = {};

      try {
        const url = poolsSummaryUrl[themeType];
        const poolsList = await api.get(`${url}/${presaleIndex}`);

        console.log({ poolsList });

        if (poolsList.data.length === 0) {
          console.error("getPublicPresaleInfo", `${url}/${presaleIndex}`);
          return;
        }

        publicPresale = poolsList.data[0];
      } catch (e) {
        console.error("getPublicPresaleInfo", e);
        publicPresale = {};
        return;
      }

      const minYesVotesThreshold = publicPresale.minYesVotesThreshold;
      const totalStakedLocked = publicPresale.totalStakedLocked;
      const releaseCycle = Number(publicPresale.releaseCycle);
      const closeTime = Number(publicPresale.closeTime);
      const releaseCliff = Number(publicPresale.releaseCliff);
      const releasePerCycle = parseInt(publicPresale.releasePerCycle) / 100;
      const releaseAtTGE = parseInt(publicPresale.releaseAtTGE) / 100;
      const cakeLiquidityAdded = publicPresale.cakeLiquidityAdded;

      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        publicPresale.presaleAddress
      );

      let fundingTokenBalance;
      let fundingTokenDecimals = 18;

      const fundingTokenContract = new web3.eth.Contract(
        config[themeType].ERC20Abi,
        publicPresale.fundingTokenAddress
      );

      if (
        isSameAddress(
          publicPresale.fundingTokenAddress,
          defaultFundingAddress[themeType]
        )
      ) {
        fundingTokenBalance =
          account && account.address
            ? await web3.eth.getBalance(account.address)
            : "0";
        fundingTokenDecimals = await fundingTokenContract.methods
          .decimals()
          .call();
      } else {
        try {
          fundingTokenBalance =
            account && account.address
              ? await fundingTokenContract.methods
                  .balanceOf(account.address)
                  .call()
              : "0";
          fundingTokenDecimals = await fundingTokenContract.methods
            .decimals()
            .call();
        } catch (e) {
          console.log(e);
        }
      }

      const url = `/pool/${presaleIndex}`;

      let maxInvestAmount = publicPresale.maxInvestInWei;
      let accountInvestment = "0";
      let claimed = "0";
      let votedBalance = "0";
      let lastClaimed = "0";
      let claimedCount = "0";
      let voteDirection = "0";
      let stakedBalance = "0";

      if (account && account.address) {
        accountInvestment = await presaleContract.methods
          .investments(account.address)
          .call({
            from: account.address,
          });

        claimed = await presaleContract.methods.claimed(account.address).call({
          from: account.address,
        });

        votedBalance = await presaleContract.methods
          .voters(account.address)
          .call();

        lastClaimed = await presaleContract.methods
          .lastClaimed(account.address)
          .call();
        claimedCount = await presaleContract.methods
          .claimedCount(account.address)
          .call();

        voteDirection = await presaleContract.methods
          .voteDirection(account.address)
          .call(); // 0 Abstained, 1 Yes, 2 No

        stakedBalance = await starterInfoContract.methods
          .getStaked(publicPresale.fundingTokenAddress, account.address)
          .call();

        if (publicPresale.presaleType === "1") {
          maxInvestAmount = await starterInfoContract.methods
            .getMaxInvestAmount(
              publicPresale.fundingTokenAddress,
              account.address,
              publicPresale.maxInvestInWei,
              publicPresale.openTime,
              publicPresale.guaranteedHours,
              publicPresale.totalTokens,
              publicPresale.tokenPriceInWei,
              publicPresale.tokenMagnitude
            )
            .call();
        }
      }

      const _tokenPrice = parseFloat(
        toFixed(
          bigInt(publicPresale.tokenPriceInWei),
          parseInt(fundingTokenDecimals) || 18,
          parseInt(fundingTokenDecimals) === 18 ? 8 : 6
        )
      );
      let tokenAmount =
        _tokenPrice > 0 && !parseInt(claimed)
          ? bigInt(accountInvestment)
              .multiply(bigInt(10).pow(publicPresale.tokenDecimals || 18))
              .divide(publicPresale.tokenPriceInWei)
              .toString()
          : "0";

      const calculatedAmount =
        _tokenPrice > 0
          ? parseFloat(
              toFixed(
                bigInt(accountInvestment),
                parseInt(fundingTokenDecimals) || 18,
                parseInt(fundingTokenDecimals) === 18 ? 8 : 6
              )
            ) / _tokenPrice
          : 0;
      const totalClaimed = parseFloat(
        toFixed(bigInt(claimed), parseInt(publicPresale.tokenDecimals) || 18, 8)
      );
      tokenAmount = parseFloat(calculatedAmount) - parseFloat(totalClaimed);

      let nextClaimTime;
      let releaseAmount = 0;
      if (claimedCount === "0") {
        releaseAmount = parseFloat(calculatedAmount) * (releaseAtTGE / 100);

        if (releaseAtTGE > 0) {
          // If there's a release at TGE, the first claim time is after closeTime
          nextClaimTime = closeTime;
        } else {
          // If there's release at TGE, it implies claims can be made immediately after closeTime
          nextClaimTime = closeTime + releaseCliff;
        }
      } else {
        let pendingClaims = 0;
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (releaseCliff > 0 && claimedCount === "1") {
          // If it's the second claim and there was a release cliff
          nextClaimTime = closeTime + releaseCliff + releaseCycle;
          pendingClaims =
            (currentTimestamp -
              (Number(publicPresale.openTime) + releaseCliff)) /
            releaseCycle;
        } else {
          // For all other claims, it's based on the last claim time
          nextClaimTime = Number(lastClaimed) + releaseCycle;
          pendingClaims =
            (currentTimestamp - Number(lastClaimed)) / releaseCycle;
        }

        releaseAmount =
          parseFloat(calculatedAmount) *
          (releasePerCycle / 100) *
          Number(pendingClaims);
      }

      if (totalClaimed + releaseAmount > parseFloat(calculatedAmount)) {
        releaseAmount = parseFloat(calculatedAmount) - totalClaimed;
      }

      const isWhitelistedAddress = publicPresale.onlyWhitelistedAddressesAllowed
        ? account && account.address
          ? await presaleContract.methods
              .whitelistedAddresses(account.address)
              .call()
          : false
        : true;

      const auditInformation = {
        auditor: web3.utils.hexToUtf8(publicPresale.auditInformation.auditor),
        isVerified: publicPresale.auditInformation.isVerified,
        isWarning: publicPresale.auditInformation.isWarning,
        linkAudit: publicPresale.auditInformation.linkAudit,
      };

      const unsoldTokensDumpAddress = await presaleContract.methods
        .unsoldTokensDumpAddress()
        .call();

      const minInvestorGuaranteedBalance = await starterInfoContract.methods
        .getMinInvestorGuaranteedBalance(publicPresale.fundingTokenAddress)
        .call();

      const claimAllowed = await presaleContract.methods.claimAllowed().call();

      if (publicPresale.presaleType === "1") {
        const investmentLimit = await starterInfoContract.methods
          .getInvestmentLimit(publicPresale.fundingTokenAddress)
          .call();

        if (bigInt(maxInvestAmount).greater(bigInt(investmentLimit))) {
          maxInvestAmount = investmentLimit;
        }
      }

      const additionalInfo = {
        tokenDecimals: publicPresale.tokenDecimals,
        kycInformation: publicPresale.kycInformation,
        description: publicPresale.description,
        whitepaper: publicPresale.whitepaper,
        categoryId: publicPresale.categoryId,
        tokenMagnitude: publicPresale.tokenMagnitude,
        presaleType: publicPresale.presaleType,
        guaranteedHours: publicPresale.guaranteedHours,
        minInvestorGuaranteedBalance,
        releasePerCycle,
        releaseAtTGE,
        releaseCliff,
        releaseCycle,
        lastClaimed,
        releaseAmount,
        totalClaimed,
        claimedCount,
        nextClaimTime,
        claimAllowed,
        saleTypeId: publicPresale.saleTypeId,
        certified: publicPresale.certified,
        visible: publicPresale.visible,
      };

      console.log({
        maxInvestInWei: publicPresale.maxInvestInWei,
      });

      const updatedPresaleInfo = {
        // ...presale,
        ...additionalInfo,
        bscsLiqLockAddress,
        presaleCreatorAddress: publicPresale.presaleCreatorAddress,
        totalInvestorsCount: publicPresale.totalInvestorsCount,
        tokenSymbol: publicPresale.tokenSymbol,
        totalCollectedWei: publicPresale.totalCollectedWei,
        totalTokens: publicPresale.totalTokens,
        totalStakedLocked,
        tokensLeft: publicPresale.tokensLeft,
        tokenPriceInWei: publicPresale.tokenPriceInWei,
        stakingTokenName,
        stakingTokenAddress,
        hardCapInWei: publicPresale.hardCapInWei,
        softCapInWei: publicPresale.softCapInWei,
        maxInvestInWei: publicPresale.maxInvestInWei,
        minInvestInWei: publicPresale.minInvestInWei,
        openTime: publicPresale.openTime,
        closeTime: publicPresale.closeTime,
        saleTitle: publicPresale.saleTitle,
        linkTelegram: publicPresale.linkTelegram,
        linkTwitter: publicPresale.linkTwitter,
        linkGithub: publicPresale.linkGithub,
        linkWebsite: publicPresale.linkWebsite,
        linkLogo: publicPresale.linkLogo,
        linkImgMain: publicPresale.linkImgMain,
        linkImgAlt1: publicPresale.linkImgAlt1,
        linkImgAlt2: publicPresale.linkImgAlt2,
        accountInvestment,
        isWhitelistMode: publicPresale.onlyWhitelistedAddressesAllowed,
        isWhitelistedAddress,
        tokenAmount,
        claimed,
        url,
        presaleIndex,
        yesVotes: publicPresale.yesVotes,
        noVotes: publicPresale.noVotes,
        minYesVotesThreshold,
        cakeLiquidityAdded,
        cakeListingPriceInWei: publicPresale.cakeListingPriceInWei,
        swapIndex: publicPresale.swapIndex,
        cakeLiquidityAddingTime: publicPresale.cakeLiquidityAddingTime,
        cakeLPTokensLockDurationInDays:
          publicPresale.cakeLPTokensLockDurationInDays,
        cakeLiquidityPercentageAllocation:
          publicPresale.cakeLiquidityPercentageAllocation,
        tokenAddress: publicPresale.tokenAddress,
        fundingTokenAddress: publicPresale.fundingTokenAddress,
        fundingTokenBalance,
        fundingTokenDecimals,
        lockedLiquidityAddress,
        lpToken: publicPresale.lpToken,
        presaleAddress: publicPresale.presaleAddress,
        presaleCancelled: publicPresale.presaleCancelled,
        auditInformation,
        votedBalance: votedBalance,
        voteDirection: voteDirection,
        stakedBalance: stakedBalance,
        voteAvailable: voteAvailable,
        unsoldTokensDumpAddress,
        description: publicPresale.description,
        maxInvestAmount,
        isBanned: false,
      };
      store.setStore({
        publicPresales: {
          ...presales,
          [presaleIndex]: updatedPresaleInfo,
        },
      });
      return emitter.emit(GET_PUBLIC_PRESALE_INFO_RETURNED);
    } catch (error) {
      console.error("GET_PUBLIC_PRESALE_INFO", error);
      return emitter.emit(ERROR, error);
    }
  };

  getStakingAndFactoryInfo = async () => {
    const provider = await this.getRpcUrl();
    const web3 = new Web3(provider);
    try {
      async.parallel(
        [
          (callbackInnerInner) => {
            _getStakingPool(
              store,
              dispatcher,
              emitter,
              web3,
              callbackInnerInner
            );
          },
          (callbackInnerInner) => {
            _getFactoryPool(
              store,
              dispatcher,
              emitter,
              web3,
              callbackInnerInner
            );
          },
        ],
        (err, data) => {
          if (err) {
            console.error("getStakingAndFactoryInfo", err);
            return emitter.emit(ERROR, err);
          }
          store.setStore({
            stakingPool: {
              address: data[0].address,
            },
            factoryPool: {
              address: data[1].address,
              stakingPool: data[1].stakingPool,
              starterInfo: data[1].starterInfo,
              owner: data[1].owner,
              pendingOwner: data[1].pendingOwner,
            },
          });
        }
      );
    } catch (err) {
      console.error("GET_PUBLIC_POOL_SUMMARY_ERROR - 1", err);
      return emitter.emit(ERROR, err);
    }
  };

  getPoolsSummary = async () => {
    const themeType = store.getStore("themeType");

    let publicPresales = {};

    try {
      const url = poolsSummaryUrl[themeType];
      const res = await api.get(url);

      publicPresales = res.data;
    } catch (e) {
      publicPresales = {};
    }

    try {
      store.setStore({
        publicPresales: {
          ...Object.values(publicPresales),
        },
      });
      return emitter.emit(GET_POOLS_SUMMARY_RETURNED);
    } catch (err) {
      console.error("GET_PUBLIC_POOL_SUMMARY_ERROR - 2", err);
      return emitter.emit(ERROR, err);
    }
  };

  write = async ({ content: { presaleIndex, method, args } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      if (presaleIndex === -1) {
        const contractAbi = store.getStore("StakedContractAbi");
        const contractAddress = store.getStore("StakedContractAddress");

        let stakedContract = new web3.eth.Contract(
          contractAbi,
          contractAddress
        );

        _callWrite(
          store,
          dispatcher,
          emitter,
          web3,
          stakedContract,
          account,
          presaleIndex,
          method,
          args,
          (err, res) => {
            if (err) {
              return emitter.emit(ERROR, err);
            }

            return emitter.emit(WRITE_RETURNED, res);
          }
        );
      } else if (presaleIndex === -2) {
        const factory = store.getStore("factory");
        const contractAbi = factory.factoryAbi;
        const contractAddress = factory.factoryAddress;

        let factoryContract = new web3.eth.Contract(
          contractAbi,
          contractAddress
        );

        _callWrite(
          store,
          dispatcher,
          emitter,
          web3,
          factoryContract,
          account,
          presaleIndex,
          method,
          args,
          (err, res) => {
            if (err) {
              return emitter.emit(ERROR, err);
            }

            return emitter.emit(WRITE_RETURNED, res);
          }
        );
      } else {
        let presaleAddress;
        presaleAddress = await starterInfoContract.methods
          .getPresaleAddress(presaleIndex)
          .call();
        const presaleContract = new web3.eth.Contract(
          _getPresaleAbiByBscsId(store, presaleIndex),
          presaleAddress
        );

        _callWrite(
          store,
          dispatcher,
          emitter,
          web3,
          presaleContract,
          account,
          presaleIndex,
          method,
          args,
          (err, res) => {
            if (err) {
              return emitter.emit(ERROR, err);
            }

            return emitter.emit(WRITE_RETURNED, res);
          }
        );
      }
    } catch (error) {
      console.error("WRITE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  swap = async ({ content: { amount, amountOut, direction } }) => {
    const themeType = store.getStore("themeType");
    const account = store.getStore("account");
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const buidlTokenAddress = store.getStore("tokenAddress");
    const swapData = store.getStore("swapData");

    const swapRouterContract = new web3.eth.Contract(
      swapData.swapRouterAbi,
      swapData.swapRouterAddress
    );

    const path =
      direction === 0
        ? [swapData.swapTokenAddress, buidlTokenAddress]
        : [buidlTokenAddress, swapData.swapTokenAddress];

    const inputToken =
      direction === 0 ? swapData.swapTokenAddress : buidlTokenAddress;

    const outputToken =
      direction === 0 ? buidlTokenAddress : swapData.swapTokenAddress;

    amount =
      inputToken === swapData.swapTokenAddress
        ? expandFixed(
            amount,
            fundingTokens[themeType].find(
              (token) => token.value === swapData.swapTokenAddress
            ).decimals
          ).toString()
        : expandFixed(amount, 18).toString();
    amountOut =
      outputToken === swapData.swapTokenAddress
        ? expandFixed(
            amountOut,
            fundingTokens[themeType].find(
              (token) => token.value === swapData.swapTokenAddress
            ).decimals
          ).toString()
        : expandFixed(amountOut, 18).toString();

    if (
      web3.utils.toChecksumAddress(inputToken) !==
      web3.utils.toChecksumAddress(
        fundingTokens[themeType].find((token) => token.label === "ETH").value
      )
    ) {
      const isApproved = await _checkApproval(
        store,
        dispatcher,
        emitter,
        config[themeType].ERC20Abi,
        inputToken,
        account,
        Web3.utils.toWei(amount.toString()),
        swapData.swapRouterAddress
      );
      if (!isApproved) {
        return emitter.emit(ERROR, {
          message: "APPROVE failed",
        });
      }
    }
    _callSwap(
      store,
      dispatcher,
      emitter,
      web3,
      account,
      swapRouterContract,
      path,
      inputToken,
      outputToken,
      amount,
      amountOut,
      (err, res) => {
        if (err) {
          return emitter.emit(ERROR, err);
        }
        return emitter.emit(SWAP_RETURNED, res);
      }
    );
  };

  customWrite = async ({ content: { address, abi, method, args } }) => {
    const account = store.getStore("account");
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const presaleContract = new web3.eth.Contract(
      _getPresaleAbiByVersion(store),
      address
    );
    _callWrite(
      store,
      dispatcher,
      emitter,
      web3,
      presaleContract,
      account,
      0,
      method,
      args,
      (err, res) => {
        if (err) {
          return emitter.emit(ERROR, err);
        }

        return emitter.emit(WRITE_RETURNED, res);
      }
    );
  };

  collectFunds = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress;
      presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callCollectFunds(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(COLLECT_FUND_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("COLLECT_FUNDS ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  cancelPresale = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress;
      presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callCancelPresale(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(CANCEL_PRESALE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("CANCEL_PRESALE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  sendUnsoldTokens = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress;
      presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callSendUnSoldTokens(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(SEND_UNSOLD_TOKENS_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("CANCEL_PRESALE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  allowClaim = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress;
      presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callAllowClaim(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(ALLOW_CLAIM_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("CANCEL_PRESALE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  invest = async (
    { content: { presaleIndex, amount, decimals = 18, disclaimer, v, r, s } },
    presaleType = "private"
  ) => {
    try {
      const themeType = store.getStore("themeType");
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const presales = store.getStore("publicPresales");
      const presale = presales[presaleIndex];
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress;
      if (presaleType === "private") {
        presaleAddress = presale.presaleAddress;
      } else {
        presaleAddress = await starterInfoContract.methods
          .getPresaleAddress(presaleIndex)
          .call();
      }
      const presaleContract =
        presaleType === "private"
          ? new web3.eth.Contract(presale.presaleAbi, presale.presaleAddress)
          : new web3.eth.Contract(
              _getPresaleAbiByBscsId(store, presaleIndex),
              presaleAddress
            );

      const weiAmount = expandFixed(amount, decimals).toString();
      // const weiAmount = bigInt(parseInt(amount * 10 ** decimals)).toString();
      const fundingTokenAddress = presaleContract.methods.fundingTokenAddress
        ? await presaleContract.methods.fundingTokenAddress().call()
        : defaultFundingAddress[themeType];

      if (
        web3.utils.toChecksumAddress(fundingTokenAddress) !==
        web3.utils.toChecksumAddress(defaultFundingAddress[themeType])
      ) {
        const isApproved = await _checkApproval(
          store,
          dispatcher,
          emitter,
          config[themeType].ERC20Abi,
          fundingTokenAddress,
          account,
          weiAmount,
          presaleAddress
        );
        if (!isApproved) {
          return emitter.emit(ERROR, {
            message: "APPROVE failed",
          });
        }
      }

      _callInvest(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        presaleType,
        fundingTokenAddress,
        weiAmount,
        disclaimer,
        v,
        r,
        s,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(INVEST_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("INVEST ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  lockLiquidity = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callLockLiquidity(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(LOCK_LIQUIDITY_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("LOCK_LIQUIDITY ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  getRefund = async ({ content: { presaleIndex } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      let presaleContract = null;

      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();

      presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );

      _callGetRefund(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(GET_REFUND_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("GET_REFUND ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  vote = async ({ content: { presaleIndex, voteType } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const factory = store.getStore("factory");
      const starterInfoContract = new web3.eth.Contract(
        factory.starterInfoAbi,
        factory.starterInfoAddress
      );
      let presaleAddress = await starterInfoContract.methods
        .getPresaleAddress(presaleIndex)
        .call();
      const presaleContract = new web3.eth.Contract(
        _getPresaleAbiByBscsId(store, presaleIndex),
        presaleAddress
      );
      _callVote(
        store,
        dispatcher,
        emitter,
        web3,
        presaleContract,
        account,
        presaleIndex,
        voteType,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(VOTE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("VOTE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  stake = async ({ content: { amount } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");

      const tokenAbi = store.getStore("StakingTokenAbi");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);
      const isApproved = await _checkApproval(
        store,
        dispatcher,
        emitter,
        tokenAbi,
        tokenAddress,
        account,
        Web3.utils.toWei(amount.toString()),
        contractAddress
      );
      if (!isApproved) {
        return emitter.emit(ERROR, {
          message: "APPROVE failed",
        });
      }

      _callStake(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        amount,
        tokenAddress,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }
          return emitter.emit(STAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("STAKE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  stakeV1 = async ({ content: { amount } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");

      const tokenAbi = store.getStore("StakingTokenAbi");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);
      const isApproved = await _checkApproval(
        store,
        dispatcher,
        emitter,
        tokenAbi,
        tokenAddress,
        account,
        Web3.utils.toWei(amount.toString()),
        contractAddress
      );
      if (!isApproved) {
        return emitter.emit(ERROR, {
          message: "APPROVE failed",
        });
      }

      _callStake(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        amount,
        tokenAddress,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(STAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("STAKE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  migrateTo = async ({ content: { amount } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");

      const tokenAbi = store.getStore("StakingTokenAbi");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);
      const isApproved = await _checkApproval(
        store,
        dispatcher,
        emitter,
        tokenAbi,
        tokenAddress,
        account,
        Web3.utils.toWei(amount.toString()),
        contractAddress
      );
      if (!isApproved) {
        return emitter.emit(ERROR, {
          message: "APPROVE failed",
        });
      }

      _callMigrate(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        tokenAddress,
        amount,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(STAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("STAKE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  moveStake = async () => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);

      let stakedInfo = await stakedContract.methods
        .accountInfos(account.address)
        .call({
          from: account.address,
        });

      const stakedBalance = bigInt(stakedInfo.balance);

      _callUnstakeV1(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        stakedInfo.balance,
        tokenAddress,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }
          this.migrateTo({
            content: {
              amount: stakedBalance.toString(),
            },
          });
          return emitter.emit(MOVE_STAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("moveStake ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  unstakeV1 = async ({ content: { amount } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);

      _callUnstakeV1(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        amount,
        tokenAddress,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }
          return emitter.emit(UNSTAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("UNSTAKE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  unstake = async ({ content: { amount } }) => {
    try {
      const account = store.getStore("account");
      const web3 = new Web3(store.getStore("web3context").library.provider);
      const contractAbi = store.getStore("StakedContractAbi");
      const contractAddress = store.getStore("StakedContractAddress");
      const tokenAddress = store.getStore("StakingToken");

      let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);

      _callUnstake(
        store,
        dispatcher,
        emitter,
        web3,
        stakedContract,
        amount,
        tokenAddress,
        account,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }
          return emitter.emit(UNSTAKE_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("UNSTAKE ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  apply = async ({
    content: {
      bscPresaleInfo,
      presalePancakeSwapInfo,
      presaleStringInfo,
      auditInfo,
    },
  }) => {
    const themeType = store.getStore("themeType");
    const account = store.getStore("account");
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const factory = store.getStore("factory");

    try {
      const factoryContract = new web3.eth.Contract(
        factory.factoryAbi,
        factory.factoryAddress
      );

      // const tokenDecimals = bigInt(10).pow(bscPresaleInfo.tokenDecimals);
      // const hardCapInWei = expandFixed(
      //   bscPresaleInfo.hardCapInWei,
      //   bscPresaleInfo.tokenDecimals
      // );
      // const liquidityPercentageAllocation = bigInt(
      //   presalePancakeSwapInfo.liquidityPercentageAllocation
      // ); // Adjust if needed
      // const listingPriceInWei = expandFixed(
      //   presalePancakeSwapInfo.listingPriceInWei,
      //   bscPresaleInfo.tokenDecimals
      // );
      // const tokenPriceInWei = expandFixed(
      //   bscPresaleInfo.tokenPriceInWei,
      //   bscPresaleInfo.tokenDecimals
      // );

      // const maxLiqPoolTokenAmount = hardCapInWei
      //   .multiply(liquidityPercentageAllocation.multiply(tokenDecimals))
      //   .divide(listingPriceInWei.multiply(bigInt(100)));

      // const maxTokensToBeSold = hardCapInWei
      //   .multiply(tokenDecimals)
      //   .divide(tokenPriceInWei);

      // const amount = maxLiqPoolTokenAmount.add(maxTokensToBeSold);

      const isApproved = await _checkApproval(
        store,
        dispatcher,
        emitter,
        config[themeType].ERC20Abi,
        bscPresaleInfo.tokenAddress,
        account,
        "9999999999999999999999999999",
        factory.factoryAddress
      );

      if (!isApproved) {
        return emitter.emit(ERROR, {
          message: "APPROVE failed",
        });
      }
      _callApply(
        store,
        dispatcher,
        emitter,
        web3,
        factoryContract,
        account,
        bscPresaleInfo,
        presalePancakeSwapInfo,
        presaleStringInfo,
        auditInfo,
        (err, res) => {
          if (err) {
            return emitter.emit(ERROR, err);
          }

          return emitter.emit(APPLY_RETURNED, res);
        }
      );
    } catch (error) {
      console.error("APPLY ERROR", error);
      return emitter.emit(ERROR, error);
    }
  };

  claim = ({ content: { presaleIndex } }, presaleType = "private") => {
    const account = store.getStore("account");

    _callClaimReward(
      store,
      dispatcher,
      emitter,
      presaleIndex,
      account,
      presaleType,
      (err, res) => {
        if (err) {
          return emitter.emit(ERROR, err);
        }

        return emitter.emit(
          presaleType === "private" ? CLAIM_RETURNED : PUBLIC_CLAIM_RETURNED,
          res
        );
      }
    );
  };

  claimHodler = (param) => {
    const account = store.getStore("account");

    _callClaimHodler(store, dispatcher, emitter, account, (err, res) => {
      if (err) {
        return emitter.emit(ERROR, err);
      }

      return emitter.emit(CLAIM_HODLER_RETURNED, res);
    });
  };
}

const store = new Store();

export default {
  store: store,
  dispatcher: dispatcher,
  emitter: emitter,
};
